export default __webpack_public_path__ + "static/media/portfolio-153.9bda03ad.jpg";